/**
 * Core utility functions for localStorage cleanup
 * Minimal, focused utilities for non-React contexts only
 * Follow Single Responsibility Principle - only handle localStorage operations
 *
 * @module utils/menuMaker/menuScopeCleanup
 */
import { LOCAL_STORAGE_MENU_SCOPE_KEY, LOCAL_STORAGE_ORG_ACCESS_KEY } from './constants';

/**
 * Clears menu scope related localStorage keys
 * Pure utility function for non-React contexts (sagas, interceptors, etc.)
 *
 * @example
 * // In a saga or API interceptor
 * import { clearMenuScopeLocalStorage } from 'utils/menuMaker/menuScopeCleanup';
 *
 * function* logoutSaga() {
 *   clearMenuScopeLocalStorage();
 * }
 */
export const clearMenuScopeLocalStorage = (): void => {
  localStorage.removeItem(LOCAL_STORAGE_MENU_SCOPE_KEY);
  localStorage.removeItem(LOCAL_STORAGE_ORG_ACCESS_KEY);
};
